import { render, staticRenderFns } from "./Nara2023Mobile.vue?vue&type=template&id=34830f7a&scoped=true&"
import script from "./Nara2023Mobile.vue?vue&type=script&lang=js&"
export * from "./Nara2023Mobile.vue?vue&type=script&lang=js&"
import style0 from "./Nara2023Mobile.vue?vue&type=style&index=0&id=34830f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34830f7a",
  null
  
)

export default component.exports